(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rafens-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
class RafensSlideshow extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.rafens-slides');
    this.slides = Array.from(this.querySelectorAll('.rafens-slide'));
    this.dots = Array.from(this.querySelectorAll('[data-dot]'));
    if (!this.track || this.slides.length < 2) return;
    this.index = 0;
    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.querySelectorAll('[data-prev]').forEach((b) => b.addEventListener('click', () => this.go(this.index - 1)));
    this.querySelectorAll('[data-next]').forEach((b) => b.addEventListener('click', () => this.go(this.index + 1)));
    this.dots.forEach((d, i) => d.addEventListener('click', () => this.go(i)));
    let raf;
    this.track.addEventListener('scroll', () => {
      if (raf) return;
      raf = requestAnimationFrame(() => { raf = null; this.sync(); });
    }, { passive: true });
    if (this.dataset.autoplay === 'true' && !this.reduced) {
      this.interval = parseInt(this.dataset.interval || '6000', 10);
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.start()));
      this.start();
    }
  }
  go(i) {
    const n = this.slides.length;
    this.index = (i + n) % n;
    this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: this.reduced ? 'auto' : 'smooth' });
    this.update();
  }
  sync() {
    const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
    if (i !== this.index) { this.index = i; this.update(); }
  }
  update() {
    this.dots.forEach((d, i) => d.setAttribute('aria-current', i === this.index ? 'true' : 'false'));
    this.slides.forEach((s, i) => s.classList.toggle('is-active', i === this.index));
  }
  start() { if (this.timer || !this.interval) return; this.timer = setInterval(() => this.go(this.index + 1), this.interval); }
  stop() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }
}
if (!customElements.get('rafens-slideshow')) customElements.define('rafens-slideshow', RafensSlideshow);

  } catch(e) { console.error(e); }
})();
})();
